export interface MerchantLink {
    id: number;
    name: string;
    url: string;
    status?: 'new' | 'changed' | 'unchanged';
}

export function stripStatus(merchantLink: MerchantLink) {
    const { status, ...linkWithoutStatus } = merchantLink;
    return linkWithoutStatus;
}